import {eventTitleKey} from './tracker-view.ts';
import type {LocalEvent} from './local-api';
import {translate} from '../i18n/catalogues.js';
export type FleetEvent={id:number;deviceId:string;displayName:string|null;type:string;occurredAt:string;zoneName?:string;probableEmptyBattery?:LocalEvent['probableEmptyBattery']};
export function fleetEventTitle(event:Pick<FleetEvent,'type'|'zoneName'|'probableEmptyBattery'>,locale='da-DK'){
 return translate(locale,eventTitleKey(event))+(event.zoneName?` · ${event.zoneName}`:'');
}
export function sortFleetEvents(events:FleetEvent[],key='time',descending=true,locale='da-DK'){
 return [...events].sort((a,b)=>{
  const main=key==='time'?Date.parse(a.occurredAt)-Date.parse(b.occurredAt):key==='device'?(a.displayName??a.deviceId).localeCompare(b.displayName??b.deviceId,locale):fleetEventTitle(a,locale).localeCompare(fleetEventTitle(b,locale),locale);
  return (main||a.id-b.id)*(descending?-1:1);
 });
}
export function fleetEventsSummary(from:string,to:string,count:number,key:string,descending:boolean,locale='da-DK'){
 const da=locale==='da-DK',date=(d:string)=>new Date(d+'T12:00:00Z').toLocaleDateString(locale,{timeZone:'Europe/Copenhagen'});
 const direction=key==='time'?(descending?(da?'nyeste først':'newest first'):(da?'ældste først':'oldest first')):(descending?'Z → A':'A → Z');
 return `${date(from)} – ${date(to)} · ${count.toLocaleString(locale)} ${da?'hændelser':'events'} · ${direction}`;
}
